export enum UPLOAD_TYPE {
  DEFAULT,
  CARD_FRONT,
  CARD_BACK,
}
